import React, { FC } from "react";
import classNames from "classnames";
import { Input, InputProps } from "antd";

import { BemHelper } from "../utils";

const bem = new BemHelper("input-auth");

export type Props = InputProps & { theme?: "light" | "dark" };

export const InputAuth: FC<Props> = ({ theme = "light", ...props }) => {
  return (
    <div className={classNames([bem.block(), theme === "dark" && bem.modifier("dark")])}>
      <Input {...props} />
    </div>
  );
};
